import {Injectable} from '@angular/core';
import {BaseDao} from '../dao.module';
import {EndpointService} from '../endpoint.service';

@Injectable()
export class LoginDaoService extends BaseDao<any> {

  constructor(endpoint: EndpointService) {
    super(endpoint);

    this.configure('/auth/login', false);
  }

  logout(key: string) {
    const url = this.getUrl(this.getEntity(null), key),
      options = this.options();

    options.secure = true;

    return this.handle(this.endpoint.delete(url, options));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/dao-service/login-dao.service.ts